import { MouvementForm } from "@features/stock/components/MouvementForm";
import { API_ENDPOINTS } from "@features/stock/config/constants";
import api from "@lib/api";
import { queryKeys } from "@lib/api/queryKeys";
import { usePermissions } from "@lib/hooks/usePermissions";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/mouvements/$id/edit")({
  loader: requirePermission(PERMISSIONS.STOCK.MOVEMENTS.EDIT),
  component: EditMouvementComponent,
});

function EditMouvementComponent() {
  const { id } = Route.useParams();
  const { can } = usePermissions();

  const { data } = useQuery({
    queryKey: queryKeys.stock.movements.detail(Number(id)),
    queryFn: async () => {
      const response = await api.get(API_ENDPOINTS.MOUVEMENT_STOCKS.DETAIL(id));
      return response.data;
    },
  });

  if (!can(PERMISSIONS.STOCK.MOVEMENTS.EDIT)) {
    return <div className="p-6">Accès non autorisé</div>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Modifier Mouvement</h1>
      {data && <MouvementForm mode="edit" initialData={data} />}
    </div>
  );
}
